import React from 'react'
import PropTypes from 'prop-types'

import { constants, strings } from 'helpers'
import HostProfileImage from 'components/HostProfileImage'
import EventCardBigContainer from './EventCardBigContainer'
import EventTime from './EventTime'
import EventLock from './EventLock'
import EventTags from './EventTags'

const {
  EVENT_CONSTANTS: { TEXT_TRIM_LENGTH },
} = constants

const EventCardBig = ({
  id,
  title,
  description,
  image,
  status,
  location,
  tagsByType,
  startTime,
  host,
  isAuthenticated,
  hideTags,
  footer,
}) => (
  <EventCardBigContainer image={image} data-eventid={id}>
    <div className="flex flex-col absolute top-0 bottom-0 p-7 w-full justify-between">
      <div className="flex">
        {isAuthenticated ? (
          <HostProfileImage src={host.logo} alt={host.name} className="rounded-full w-10 h-10" />
        ) : (
          <EventLock />
        )}
        <EventTime
          startTime={startTime}
          status={status}
          classNames={{ wrapper: 'ml-3', countdown: 'text-base', date: 'secondary-text' }}
        />
      </div>
      <div className="flex xl:flex-wrap items-end">
        <div className="w-full max-w-xl pr-5 xl:max-w-2xl xl:pr-0">
          {!hideTags && <EventTags location={location} tagsByType={tagsByType} />}
          <h2 className="text-white mt-1.5 overflow-hidden overflow-ellipsis leading-tight">
            {strings.trim(title, TEXT_TRIM_LENGTH.TITLE)}
          </h2>
          <h5
            className="text-gray-400 overflow-hidden overflow-ellipsis text-lg mt-3"
            dangerouslySetInnerHTML={{
              __html: strings.trim(description, TEXT_TRIM_LENGTH.DESCRIPTION),
            }}
          />
        </div>
        {!!footer && <div className="w-1/2 xl:w-full">{footer}</div>}
      </div>
    </div>
  </EventCardBigContainer>
)

EventCardBig.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  location: PropTypes.string,
  startTime: PropTypes.string,
  status: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  host: PropTypes.shape({
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  hideTags: PropTypes.bool,
  footer: PropTypes.element,
}

export default EventCardBig
